import React from "react";
import { Flex, Switch, Tooltip, Text, Select } from "@chakra-ui/react";
import { getBid } from "../../lib/Auth";

const bid = getBid();
const sendHoursBefore = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 48, 72, 96, 120, 144, 168];
const updateInterval = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 30, 36];

export default function HistorySettingsControls({
  template,
  updateTemplateField
}) {
  // normalize per-business flags that may be stored either as booleans or keyed objects
  const enabledForBid = typeof template.enabled === 'object' ? template.enabled?.[bid] : template.enabled;
  const autoSendForBid = typeof template.auto_send_to_new_patients === 'object' ? template.auto_send_to_new_patients?.[bid] : template.auto_send_to_new_patients;
  const sendEmailForBid = typeof template.send_email === 'object' ? template.send_email?.[bid] : template.send_email;
  const sendTextForBid = typeof template.send_text === 'object' ? template.send_text?.[bid] : template.send_text;
  return (
    <>
      <Flex direction={'column'}>
      <Flex alignItems='center' gap={4}>
        <Flex gap={4}>
          {template.bid === bid ? (
            <Flex gap={2}>
              <Switch
                isChecked={template.shared}
                onChange={(e) => {
                  updateTemplateField(template, "shared", e.target.checked);
                }}
              />
              <Tooltip label="Share this form with other locations" hasArrow>
                <Flex>Share (with other locations)</Flex>
              </Tooltip>
            </Flex>
          ) : (
            <Text>Shared by {template.owner}</Text>
          )}
        </Flex>
      </Flex>

      <Flex alignItems="center" gap={4} mt={4}>
        <Flex gap={2}>
          <Switch
            isDisabled={!template._id}
            isChecked={enabledForBid}
            onChange={(e) => {
              updateTemplateField(template, "enabled", e.target.checked);
            }}
          />
          <Flex>Active</Flex>
        </Flex>
      </Flex>

      <Flex ml={2}>
        <Tooltip label="Select Active to enable this feature" hasArrow isDisabled={enabledForBid}>
          <Flex align="center" gap={4}>
            <Switch
              disabled={!enabledForBid}
              isChecked={autoSendForBid}
              onChange={(e) => {
                updateTemplateField(template, "auto_send_to_new_patients", e.target.checked);
              }}
            />
            <Flex>Auto Send to Patients</Flex>
          </Flex>
        </Tooltip>
      </Flex>

      <Flex ml={4} gap={4}>
        <Flex alignItems="left" gap={4}>
          <Tooltip
            label="Select Auto Send to enable this feature"
            hasArrow
            isDisabled={autoSendForBid}
          >
            <Flex align="center" gap={2}>
              <Switch
                disabled={!(enabledForBid && autoSendForBid)}
                isChecked={sendEmailForBid}
                onChange={(e) => {
                  updateTemplateField(template, "send_email", e.target.checked);
                }}
              />
              <Flex color={!autoSendForBid && "grey"}>
                Send Email
              </Flex>
            </Flex>
          </Tooltip>
          <Tooltip
            label="Select Auto Send to enable this feature"
            hasArrow
            isDisabled={autoSendForBid}
          >
            <Flex align="center" gap={2}>
              <Switch
                disabled={!(enabledForBid && autoSendForBid)}
                isChecked={sendTextForBid}
                onChange={(e) => {
                  updateTemplateField(template, "send_text", e.target.checked);
                }}
              />
              <Flex color={!autoSendForBid && "grey"}>
                Send SMS
              </Flex>
            </Flex>
          </Tooltip>
        </Flex>
      </Flex>

      <Flex ml={4}>
        <Flex align="center" gap={2}>
          <Flex
            justifyContent='flex-start'
            color={!autoSendForBid && "grey"}
          >
            Hours before next appointment
          </Flex>
          <Tooltip
            label="Select Auto Send to enable this feature"
            hasArrow
            isDisabled={autoSendForBid}
          >
            <Flex>
              <Select
                disabled={!autoSendForBid}
                value={ template.shared_hours_before?.[bid] || template.send_hours_before_first_appointment || 1
                }
                onChange={(e) => updateTemplateField(template, "send_hours_before_first_appointment", Number(e.target.value))}
              >
                {sendHoursBefore.map((o, i) => (
                  <option key={i} value={o}>
                    {o <= 24 ? o : `${o/24} days`}
                  </option>
                ))}
              </Select>
            </Flex>
          </Tooltip>
        </Flex>
      </Flex>

      <Flex ml={2}>
        <Tooltip label="Select Active to enable this feature" hasArrow isDisabled={enabledForBid} >
          <Flex align="center" gap={4}>
          <Switch
            isDisabled={!autoSendForBid || !enabledForBid}
            isChecked={template.shared_questionnaire_reminder?.[bid]?.enabled}
              onChange={(e) => {
                updateTemplateField(template, "questionnaire_history_update_reminder", e.target.checked);
              }}
            />
          <Flex>Patient history update schedule</Flex>
          </Flex>
        </Tooltip>
      </Flex>

      <Flex ml={4}>
        <Flex align="center" gap={2}>
          <Flex justifyContent='flex-start' color={!template.shared_questionnaire_reminder?.[bid]?.enabled && "grey"}>
            Questionnaire update interval (Months)
          </Flex>
          <Tooltip
            label="Select Patient history update schedule to enable this feature"
            hasArrow
            isDisabled={template.shared_questionnaire_reminder?.[bid]?.enabled}
          >
            <Flex>
              <Select
                disabled={!autoSendForBid || !enabledForBid || !template.shared_questionnaire_reminder?.[bid]?.enabled}
                value={
                  (template?.shared_questionnaire_reminder?.[bid]?.interval_months) ||
                      template.questionnaire_history_update_interval || 1
                }
                onChange={(e) => updateTemplateField(template, "questionnaire_history_update_interval", e.target.value)}
              >
                {updateInterval.map((o, i) => (
                  <option key={i} value={o.value}>
                    {o}
                  </option>
                ))}
              </Select>
            </Flex>
          </Tooltip>
        </Flex>
      </Flex>
      </Flex>
    </>
  );
}
